import { StoreErrorHandler } from '~app/shared/errors/store-errors-handler';
import { HelpTopic } from './help-topic.model';

export class LoadOne {
  static readonly type = '[HelpTopic] LoadOne';
  constructor(public domain: string, public key: string) {}
}
export class LoadOneSuccess {
  static readonly type = '[HelpTopic] LoadOneSuccess';
  constructor(public data: HelpTopic) {}
}
export class LoadOneFailure {
  static readonly type = '[HelpTopic] LoadOneFailure';
  constructor(public error: any) {
    StoreErrorHandler.handleError(error);
  }
}

